<template lang="pug">
    div(
        :class="!inert && '_btnh'",
        @mouseover="mouseover",
        @mouseleave="mouseleave",
        @mousedown="mousedown",
        @mouseup="mouseup",
        @touchstart="mousedown",
        @touchend="mouseup",
        @click="fwd")
        slot
</template>

<script>
    import $util from '../../prototype/util';

    const find = [].find;


    /**
     * A container that forwards mouse events to the first enclosed button. Events forwarded
     * include: hover, leave, mousedown, mouseup, click.
     */
    export default {
        name: 'ib-button-hook',

        props: {
            /**
             * Toggles inert behavior for the whole button hook
             */
            inert: Boolean
        },

        mounted() {
            if (this.$device.ios) {
                this.$el.addEventListener('touchstart', this.noop, true);
            }
        },

        methods: {
            pass(e) {
                let el = e.target;
                while (el && el.tagName != 'BUTTON') {
                    el = el.parentElement;
                }
                return !el;
            },

            input(e) {
                return this.inert ? null : find.call(this.$el.getElementsByTagName('BUTTON'), el => $util.component(el)?.click);
            },

            mouseover(e) {
                const el = this.input();
                if (el && this.pass(e)) {
                    el.classList.add('hover');
                } else {
                    this.mouseleave();
                }
            },

            mouseleave() {
                const el = this.input();
                if (el) {
                    el.classList.remove('hover');
                    el.classList.remove('_active');
                }
            },

            mousedown(e) {
                const el = this.input();
                if (el && this.pass(e)) {
                    el.classList.add('_active');
                }
            },

            mouseup(e) {
                const el = this.input();
                if (el) {
                    el.classList.remove('_active');
                }
            },

            fwd(e) {
                const el = this.input();
                if (el && this.pass(e)) {
                    $util.component(el).click();
                }
            },

            noop() {
                // empty
            }
        }
    }
</script>

<style lang="less">
    @import "../../less/globals.less";

    ._btnh {
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
    }
</style>

<docs>
    Basic Example:
    ```jsx
        new Vue({
            data() {
                return {
                    buttonClicked: false
                }
            },
            template:
                `<ib-context>
                    <ib-button-hook>
                        <ib-button @click="buttonClicked = !buttonClicked">Button 1</ib-button>
                    </ib-button-hook>
                    <p v-show="buttonClicked">That really pushes my buttons!</p>
                </ib-context>`
        })
    ```
</docs>
